// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZjiW1BG7GHrkVN9gQJ8Q {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* The switch - the box around the slider */
.jfZzsLh5DfgsHzJdRWDr {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.jfZzsLh5DfgsHzJdRWDr input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.zpXj9Qt0X1bsBwphv7qQ {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
}

.zpXj9Qt0X1bsBwphv7qQ:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .zpXj9Qt0X1bsBwphv7qQ {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

input:focus + .zpXj9Qt0X1bsBwphv7qQ {
  box-shadow: 0 0 1px ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

input:checked + .zpXj9Qt0X1bsBwphv7qQ:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.HXO0FExZcv2CeE0qHRQQ {
  margin-left: 10px;
  margin-bottom: 0;
  margin-top: 0;
}

.utKJplxEWD7nG9b9V8JD {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/Switch/Switch.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8DAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8DAA8B;AAChC;;AAEA;EACE,gEAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mDAAiB;AACnB","sourcesContent":["@value colors: \"../../style/colors.css\";\r\n@value color-purple, color-purple-bg, color-text from colors;\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n/* The switch - the box around the slider */\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 60px;\r\n  height: 34px;\r\n}\r\n\r\n/* Hide default HTML checkbox */\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n/* The slider */\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: color-purple-bg;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n  border-radius: 34px;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: white;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n  border-radius: 50%;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: color-purple;\r\n}\r\n\r\ninput:focus + .slider {\r\n  box-shadow: 0 0 1px color-purple;\r\n}\r\n\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(26px);\r\n  -ms-transform: translateX(26px);\r\n  transform: translateX(26px);\r\n}\r\n\r\n.label {\r\n  margin-left: 10px;\r\n  margin-bottom: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.labelDisabled {\r\n  color: color-text;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]}`,
	"container": `ZjiW1BG7GHrkVN9gQJ8Q`,
	"switch": `jfZzsLh5DfgsHzJdRWDr`,
	"slider": `zpXj9Qt0X1bsBwphv7qQ`,
	"label": `HXO0FExZcv2CeE0qHRQQ`,
	"labelDisabled": `utKJplxEWD7nG9b9V8JD`
};
export default ___CSS_LOADER_EXPORT___;
